import type { ColumnDef } from '@tanstack/react-table';

import { type GetBakeryRecordsQuery } from 'data/__generated__';
import { textColumn, numberColumn, dateColumn } from 'components/DataTable';

export type BakeryRecordRow = GetBakeryRecordsQuery['bakeryRecords'][number];

export const bakeryRecordsColumns: ColumnDef<BakeryRecordRow, unknown>[] = [
    textColumn<BakeryRecordRow, never>({
        accessorKey: 'fullname',
        header: 'Nom de produit',
        defaultVisible: true,
    }),
    dateColumn<BakeryRecordRow, never>({
        accessorKey: 'useDate',
        header: 'Date de cuisson',
        defaultVisible: true,
    }),
    numberColumn<BakeryRecordRow, never>({
        accessorKey: 'quantityUsed',
        header: 'Quantit\u00e9s cuites',
        defaultVisible: true,
    }),
    textColumn<BakeryRecordRow, never>({
        accessorKey: 'serialNumber',
        header: 'N\u00ba du carton',
        defaultVisible: true,
    }),
];
